var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "typeahead",
      attrs: {
        id: "typeahead-" + _vm.id,
        "aria-owns": "result-list-" + _vm.id,
        "aria-expanded":
          _vm.isFocused && _vm.data.length > 0 ? "true" : "false",
        role: "combobox",
        "aria-haspopup": "listbox"
      }
    },
    [
      _c("div", { class: _vm.inputGroupClasses }, [
        _vm.$slots.prepend || _vm.prepend
          ? _c(
              "div",
              { ref: "prependDiv", staticClass: "input-group-prepend" },
              [
                _vm._t("prepend", [
                  _c("span", { staticClass: "input-group-text" }, [
                    _vm._v(_vm._s(_vm.prepend))
                  ])
                ])
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c("input", {
          ref: "input",
          class: [
            "form-control",
            _vm.inputClass,
            _vm.state !== null && {
              "is-invalid": !_vm.state,
              "is-valid": _vm.state
            }
          ],
          attrs: {
            id: "typeahead-input-" + _vm.id,
            "aria-labelledby": _vm.ariaLabelledBy,
            "aria-controls": "result-list-" + _vm.id,
            "aria-activedescendant": "selected-option-" + _vm.id,
            name: _vm.inputName,
            placeholder: _vm.placeholder,
            "aria-label": !_vm.ariaLabelledBy ? _vm.placeholder : false,
            disabled: _vm.disabled,
            type: "text",
            role: "searchbox",
            "aria-multiline": "false",
            "aria-autocomplete": "list",
            autocomplete: "off"
          },
          domProps: { value: _vm.inputValue },
          on: {
            focus: _vm.handleFocus,
            blur: _vm.handleFocusOut,
            input: function($event) {
              return _vm.handleInput($event.target.value)
            },
            keydown: [
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "esc", 27, $event.key, [
                    "Esc",
                    "Escape"
                  ])
                ) {
                  return null
                }
                return _vm.handleEsc($event.target.value)
              },
              function($event) {
                return _vm.$emit("keydown", $event)
              }
            ],
            keyup: function($event) {
              return _vm.$emit("keyup", $event)
            },
            paste: function($event) {
              return _vm.$emit("paste", $event)
            }
          }
        }),
        _vm._v(" "),
        _vm.$slots.append || _vm.append
          ? _c(
              "div",
              { staticClass: "input-group-append" },
              [
                _vm._t("append", [
                  _c("span", { staticClass: "input-group-text" }, [
                    _vm._v(_vm._s(_vm.append))
                  ])
                ])
              ],
              2
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.loading
        ? _c("div", { staticClass: "loading" }, [_vm._m(0)])
        : _vm._e(),
      _vm._v(" "),
      _c("vue-bootstrap-autocomplete-list", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.isFocused &&
              (_vm.data.length > 0 ||
                !!_vm.$scopedSlots.noResultsInfo ||
                !!_vm.noResultsInfo),
            expression:
              "isFocused && (data.length > 0 || !!$scopedSlots.noResultsInfo || !!noResultsInfo)"
          }
        ],
        ref: "list",
        staticClass: "vbt-autocomplete-list",
        attrs: {
          id: "result-list-" + _vm.id,
          query: _vm.inputValue,
          data: _vm.formattedData,
          backgroundVariant: _vm.backgroundVariant,
          backgroundVariantResolver: _vm.backgroundVariantResolver,
          textVariant: _vm.textVariant,
          maxMatches: _vm.maxMatches,
          minMatchingChars: _vm.minMatchingChars,
          noResultsInfo: _vm.noResultsInfo,
          disableSort: _vm.disableSort,
          showOnFocus: _vm.showOnFocus,
          showAllResults: _vm.showAllResults,
          highlightClass: _vm.highlightClass,
          disabledValues: _vm.disabledValues,
          vbtUniqueId: _vm.id,
          showCreate: _vm.showCreate,
          role: "listbox"
        },
        on: { hit: _vm.handleHit, listItemBlur: _vm.handleChildBlur },
        scopedSlots: _vm._u(
          [
            _vm._l(_vm.$scopedSlots, function(slot, slotName) {
              return {
                key: slotName,
                fn: function(ref) {
                  var data = ref.data
                  var htmlText = ref.htmlText
                  return [
                    _vm._t(slotName, null, null, {
                      data: data,
                      htmlText: htmlText
                    })
                  ]
                }
              }
            })
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", [_c("i", { staticClass: "fas fa-spinner spin" })])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a4b11e4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a4b11e4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/lib/autocomplete/VueBootstrapAutocomplete.vue
// module id = null
// module chunks = 